<template>
  <div id="code_pro" class="menucontent" v-if="showModal">
    <div class="inmenucontent animate__animated animate__bounceIn" :style="{ backgroundImage: createBackgroundString }">
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct px-3">
        <div class="menuhead mb-3">
          <i class="fas fa-code"></i> CODE โปรโมชั่น
        </div>
        <div class="depositimg">
          <img src="./../../assets/moneyback.png" />
        </div>
        <div class="animate__animated animate__flipInX">
          <div class="form-group mb-4">
            <input
              type="text"
              id="code_input"
              class="form-control text-center p-0 py-2"
              placeholder="ใส่ Code กิจกรรม"
              style="font-size: 1.2em !important; font-weight: bold"
              v-model="Form.Code"
            />
          </div>
          <button type="button" class="loginbtn mt-0 mb-3" @click="onSubmit">
            <span> ยืนยัน </span>
          </button>
          <div class="text-center">
            แหล่งหา Code กิจกรรม
            <a target="_blank" style="color: gold"><u>รายละเอียด</u></a>
          </div>
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";
export default {
  name: "codemodal-component",
  data() {
    return {
      showModal: false,
      Form: {
        Code: "",
      },
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    onSubmit() {
      if (this.Form.Code != "") {
        let homeCont = this.$refs.homeCont;
        let loader = this.$loading.show({
          container: homeCont,
          loader: "Dots",
          color: "red",
          opacity: 0.5,
          backgroundColor: "#000000",
        });
        // document.getElementById("submitCode").disabled = true;
        HTTP.post(`member/code`, {
          code: this.Form.Code,
        })
          .then((resp) => {
            // document.getElementById("submitCode").disabled = false;
            if (resp.data.status != undefined && !resp.data.status) {
              this.$toast.error(
                resp.data.msg != undefined
                  ? resp.data.msg
                  : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
              );
            } else {
              this.$toast.success("สำเร็จ");
              this.hide();
            }
          })
          .catch((err) => {
            // document.getElementById("submitCode").disabled = false;
                this.$toast.error(
                  err.data.msg != undefined
                    ? err.data.msg
                    : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
                );
          })
          .then(() => {
            loader.hide();
          });
      } else {
        this.$toast.error("กรุณากรอก Code");
      }
    },
  },
  computed: {
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  }
};
</script>

<style></style>
